import { devLog } from "utils/devtools/devLogging";

export interface ICurrentSite {
  name?: string;
}

export async function getCurrentSite(): Promise<ICurrentSite | null> {
  try {
    // Not through apiReq: it signs the user out on any 401, and Pathfinder is a separate origin with its
    // own auth. Relative path keeps it same-origin, so the nomine cookie it needs is sent by default
    const response = await fetch("/api/platform/currentSite");
    if (!response.ok) return null;

    return (await response.json()) as ICurrentSite;
  } catch (error) {
    devLog({
      extra: { error: error instanceof Error ? error.message : String(error) },
      level: "warn",
      message: "Could not read the current site from Pathfinder",
    });
    return null;
  }
}
